// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1bp2o","subheader":"ReorderModal_subheader__1hQlV","listWrap":"ReorderModal_listWrap__2eMnb","inactiveWrap":"ReorderModal_inactiveWrap__3ctHX"};